export const Hardware = {
  CLOCK_PULSE: 0,
  LEFT_DOWN: 1,
  RIGHT_DOWN: 2,
  DOWN_DOWN: 3,
  ROTATE_CW_DOWN: 4,
  ROTATE_CCW_DOWN: 5,
  HARD_DROP_DOWN: 6,
  HOLD_DOWN: 7,
  PAUSE_DOWN: 8,
  RESTART_DOWN: 9,
  START_DOWN: 10,
  LEFT_UP: 11,
  RIGHT_UP: 12,
  DOWN_UP: 13,
  ROTATE_CW_UP: 14,
  ROTATE_CCW_UP: 15,
  HARD_DROP_UP: 16,
  HOLD_UP: 17,
  PAUSE_UP: 18,
  RESTART_UP: 19,
  START_UP: 20,
} as const;

